export default __webpack_public_path__ + "static/Adding Notes in admin portal FINISHED-4896faac12650bce546391c24aad352c.mp4";